class CartDrawerMilestones {
  constructor(root) {
    this.root = root;

    this.statusEl = root.querySelector('[data-cart-milestones-status]');
    this.fillEl = root.querySelector('[data-cart-milestones-fill]');
    this.pointsEl = root.querySelector('[data-cart-milestones-points]');
    this.jsonEl = root.querySelector('[data-cart-milestones-json]');

    this.completeText = root.dataset.completeText || 'You have unlocked all rewards';

    this.milestones = this.getMilestones();
    this.lastCompletedCount = null;

    this.update();

    requestAnimationFrame(() => {
      this.root.classList.add('is-ready');
    });
  }

  getMilestones() {
    if (!this.jsonEl) return [];

    try {
      const milestones = JSON.parse(this.jsonEl.textContent || '[]');

      return milestones
        .map((milestone) => ({
          amount: Number(milestone.amount),
          label: String(milestone.label || '').trim(),
        }))
        .filter((milestone) => milestone.amount > 0 && milestone.label)
        .sort((a, b) => a.amount - b.amount)
        .slice(0, 4);
    } catch (error) {
      console.error('Cart milestones JSON error:', error);
      return [];
    }
  }

  async getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });

    return response.json();
  }

  async update() {
    if (!this.statusEl || !this.fillEl || !this.pointsEl || !this.milestones.length) return;

    try {

      const cart = await this.getCart();
      const total = cart.total_price / 100;

      this.updateUI(total);
    } catch (error) {
      console.error('Cart milestones update error:', error);
    }
  }

  updateUI(total) {
    const finalMilestone = this.milestones[this.milestones.length - 1];
    const maxAmount = finalMilestone.amount;

    const progress = Math.min(total / maxAmount, 1);
    const completedMilestones = this.milestones.filter((milestone) => total >= milestone.amount);
    const completedCount = completedMilestones.length;
    const nextMilestone = this.milestones.find((milestone) => total < milestone.amount);

    this.fillEl.style.width = `${progress * 100}%`;

    if (nextMilestone) {
      const remaining = Math.max(nextMilestone.amount - total, 0);

     this.setStatusHTML(`
        Add <strong>${this.formatMoney(remaining)}</strong> more to unlock
        <strong>${this.escapeHTML(nextMilestone.label)}</strong>
    `);
    } else {
      this.setStatusHTML(this.escapeHTML(this.completeText));
    }

    this.pointsEl.querySelectorAll('[data-cart-milestone-point]').forEach((point, index) => {
      const milestone = this.milestones[index];
      const isComplete = total >= milestone.amount;
      const isNext = nextMilestone && milestone.amount === nextMilestone.amount;

      point.classList.toggle('is-complete', isComplete);
      point.classList.toggle('is-next', Boolean(isNext));

      point.classList.remove('is-just-unlocked');

      if (
        this.lastCompletedCount !== null &&
        completedCount > this.lastCompletedCount &&
        index === completedCount - 1
      ) {
        point.classList.add('is-just-unlocked');

        window.setTimeout(() => {
          point.classList.remove('is-just-unlocked');
        }, 700);
      }
    });

    this.lastCompletedCount = completedCount;
  }


  formatMoney(amount) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount * 100);
    }

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  }

  escapeHTML(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  setStatusHTML(html) {
    if (!this.statusEl) return;

    const currentHTML = this.statusEl.innerHTML.trim();
    const nextHTML = String(html).trim();

    if (currentHTML === nextHTML) return;

    this.statusEl.classList.add('is-changing');

    window.setTimeout(() => {
        this.statusEl.innerHTML = nextHTML;

        requestAnimationFrame(() => {
        this.statusEl.classList.remove('is-changing');
        });
    }, 160);
    }
}

function initCartDrawerMilestones() {
  document.querySelectorAll('[data-cart-milestones]').forEach((el) => {
    const existingInstance = el._cartMilestonesInstance;

    if (!existingInstance) {
      el._cartMilestonesInstance = new CartDrawerMilestones(el);
      return;
    }

    existingInstance.root = el;
    existingInstance.statusEl = el.querySelector('[data-cart-milestones-status]');
    existingInstance.fillEl = el.querySelector('[data-cart-milestones-fill]');
    existingInstance.pointsEl = el.querySelector('[data-cart-milestones-points]');
    existingInstance.jsonEl = el.querySelector('[data-cart-milestones-json]');
    existingInstance.completeText = el.dataset.completeText || 'You have unlocked all rewards';
    existingInstance.milestones = existingInstance.getMilestones();

    existingInstance.update();

    requestAnimationFrame(() => {
      existingInstance.root.classList.add('is-ready');
    });
  });
}

let cartMilestonesTimer = null;

function scheduleCartMilestonesUpdate() {
  clearTimeout(cartMilestonesTimer);

  cartMilestonesTimer = setTimeout(() => {
    initCartDrawerMilestones();
  }, 120);
}

document.addEventListener('DOMContentLoaded', initCartDrawerMilestones);
document.addEventListener('shopify:section:load', initCartDrawerMilestones);

[
  'cart:update',
  'cart:updated',
  'cart:refresh',
  'cart:change',
  'cart:changed',
  'cart-drawer:open',
  'dialog:open',
].forEach((eventName) => {
  document.addEventListener(eventName, scheduleCartMilestonesUpdate);
});

// const cartMilestonesObserver = new MutationObserver(() => {
//   scheduleCartMilestonesUpdate();
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const drawer = document.querySelector('cart-drawer-component');

//   if (drawer) {
//     cartMilestonesObserver.observe(drawer, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//     });
//   }
// });

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args);

  try {
    const requestUrl = String(args[0]);

    if (
      requestUrl.includes('/cart/add') ||
      requestUrl.includes('/cart/change') ||
      requestUrl.includes('/cart/update') ||
      requestUrl.includes('/cart/clear')
    ) {
      scheduleCartMilestonesUpdate();
    }
  } catch (error) {
    // Silent fallback
  }

  return response;
};